// extracted by mini-css-extract-plugin
module.exports = {"responsive":"mystyle_responsive__1AFqK","responsive2":"mystyle_responsive2__qlI5k","responsive3":"mystyle_responsive3__2TjOC","each-fade":"mystyle_each-fade__1g5kt"};